var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.list},scopedSlots:_vm._u([{key:"item.discount_type",fn:function({ item }){return [_c('span',[_vm._v(_vm._s(_vm.discountTypes[item.discount_type].label))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }